// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.messaging.UpdateMessageParticipantPersonFolderRequest */
/* istanbul ignore next */
@GandalfModel
export class UpdateMessageParticipantPersonFolderRequest extends GandalfModelBase {

	@GandalfLabel('Folder')
	@GandalfValidator({ notNull: { message: 'Folder is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	messageFolderId!: number;

	@GandalfLabel('Message Participant')
	@GandalfValidator({ notNull: { message: 'Message Participant is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	messageParticipantPersonId!: number;

}
